import { render, staticRenderFns } from "./introducePage.vue?vue&type=template&id=b8de2d58&scoped=true&"
import script from "./introducePage.vue?vue&type=script&lang=js&"
export * from "./introducePage.vue?vue&type=script&lang=js&"
import style0 from "./introducePage.vue?vue&type=style&index=0&id=b8de2d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8de2d58",
  null
  
)

export default component.exports